/** Which side of a coaching conversation a message came from. */
export enum ECoachChatSenderType {
  Coach = 1,
  Student = 2,
}

export interface IChatMessage {
  id: number;
  conversationId: number;
  senderType: ECoachChatSenderType;
  senderUserId: number;
  body: string;
  createdAt: string;
}

/** What the conversation endpoint reports before any message is loaded. */
export interface IChatConversation {
  conversationId: number;
  unreadCount: number;
  lastMessageAt: string | null;
}
